// extracted by mini-css-extract-plugin
export default {"StudentRightSideContent":"StudentRightSideContent_StudentRightSideContent__UJyB5"};